<template>
  <div class="index-box">
    <div class="all-center-box">
      <div class="w-1500">
        <div class="home-box1 w-100">
          <div class="pull-left">
            <div class="box-info1 w-100"><span>产品分类</span></div>
            <div class="box-info2 w-100 hide-scrollbar">
              <ul>
                <li v-for="(item, index) in categorys" :key="index" @click.stop="handleFilterCategory(item)">
                  <!-- @click.stop="pageJump('/productTypeScreen', item, {})" -->
                  <span><a>{{ item.name }}</a></span>
                  <div class="erji" v-if="item.children.length > 0">
                    <div class="box1 w-100">
                      <span>{{ item.name }}</span>
                    </div>
                    <div class="box2 w-100">
                      <ul>
                        <li v-for="(item2, index2) in item.children" :key="index2" @click.stop="
                          pageJumps('/productTypeScreen', item2, item)
                          ">
                          <a>{{ item2.name }}</a>
                        </li>
                        <img :src="item.accessory
                          ? item.accessory.oriUrl
                          : '/static/img/J.png'
                          " class="erjiImg" />
                      </ul>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="pull-cen">
            <div class="swiper-container">
              <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(item, index) in indexSlide" :key="index" @click="goProductDetail(item)">
                  <div :style="{ cursor: item.imgUrl ? 'pointer' : 'default' }">
                    <img :src="item.imgUrl" :alt="item.name" />
                  </div>
                </div>
              </div>
              <div class="swiper-pagination"></div>
            </div>
            <!-- <ul class="link-box">
							<li><a @click="navTo('配件专区')"><img src="../assets/images/img_5.jpg"></a></li>
							<li><a @click="navTo('轴承专区')"><img src="../assets/images/img_6.jpg"></a></li>
							<li><a @click="navTo('电商平台')"><img src="../assets/images/img_7.jpg"></a></li>
						</ul> -->
          </div>
          <div class="pull-right">
            <div class="box-info1 w-100 center-center">
              <i><img :src="userInfo.headimgUrl
                ? userInfo.headimgUrl
                : '/static/img/icon_7.png'
                " /></i>
              <p>Hi ~ 欢迎来到汇利兴</p>
              <div v-if="!token">
                <a href="javascript:;" onclick="$('.login-eject').fadeIn();">登录</a>
                <router-link to="/register">注册</router-link>
              </div>
            </div>
            <div class="box-info2 w-100">
              <div class="top-box w-100">
                <span v-for="(item, index) in tabbar" :class="{ active: tabbarIndex == index }" :key="index"
                  @mouseenter="changeTabbar(index)">{{ item }}</span>
              </div>
              <div class="lower-box w-100" v-show="tabbarIndex == 0">
                <div class="box1 w-100">
                  <ul>
                    <li>
                      <!-- <router-link
                        :to="{ path: '/meOrder', query: { data: 1 } }"
                      >
                        <i>
                          <img src="../assets/images/icon_dd1.png" />
                        </i>
                        <p>待支付</p>
                      </router-link> -->
                      <!-- :to="{ path: '/meOrder', query: { data: 1 } }" -->
                      <a href="javascript:;" @click="token ? navToOrder('meOrder', '1') : goLogin()">
                        <i>
                          <img src="../assets/images/icon_dd1.png" />
                        </i>
                        <p>跟进中</p>
                      </a>
                    </li>
                    <!-- <li>
                      <a href="javascript:;" @click="token ? navToOrder('meOrder', '10') : goLogin()"><i><img
                            src="../assets/images/icon_dd3.png" /></i>
                        <p>待收货</p>
                      </a>
                    </li>
                    <li>
                      <a href="javascript:;" @click="token ? navToOrder('meOrder', '15') : goLogin()">
                        <i><img src="../assets/images/icon_dd2.png" /></i>
                        <p>已收货</p>
                      </a>
                    </li> -->
                    <li>
                      <a href="javascript:;" @click="token ? navToOrder('meOrder', '') : goLogin()"><i><img
                            src="../assets/images/icon_dd4.png" /></i>
                        <p>全部订单</p>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="lower-box w-100" v-show="tabbarIndex == 1">
                <div class="box1 w-100">
                  <ul>
                    <li>
                      <a @click="navToInquiry(1)"><i><img src="../assets/images/icon_dd1.png" /></i>
                        <p>跟进中</p>
                      </a>
                    </li>
                    <li>
                      <a @click="navToInquiry(2)"><i><img src="../assets/images/icon_dd2.png" /></i>
                        <p>已成交</p>
                      </a>
                    </li>
                    <li>
                      <a @click="navToInquiry(3)"><i><img src="../assets/images/icon_dd4.png" /></i>
                        <p>已终止</p>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="true" class="home-box2 w-100">
          <ul style="display: flex; justify-content: space-between;align-items: center;">
            <li style="flex: 1;">
              <a @click="cadUrl">
                <!-- <img src="../assets/images/ho2_image1.png" /> -->
                <img src="../assets/images/home_sjgj.png" />
              </a>
            </li>
            <li style="flex: 1;">
              <a @click="undeveloped()">
                <!-- <img src="../assets/images/ho2_image2.png" /> -->
                <img src="../assets/images/home_3d.png" />
              </a>
            </li>
            <!-- <li>
              <a @click="undeveloped()"
                ><img src="../assets/images/ho2_image3.png"
              /></a>
            </li> -->
            <li style="flex: 1;">
              <router-link to="/quickQuotation">
                <!-- <img src="../assets/images/ho2_image4.png" /> -->
                <!-- <img src="../assets/images/home_bj.png" /> -->
                <img src="../assets/images/hom_jgzx.jpg" style="border-radius: 4px;" />
              </router-link>
            </li>
            <!-- <li>
              <a @click="undeveloped()"
                ><img src="../assets/images/ho2_image5.png"
              /></a>
            </li> -->
          </ul>
        </div>
        <div class="home-box3 w-100" v-for="(list, index) in indexGoodsListArry" :key="list.id">
          <div class="all-title-box w-100 between-center">
            <div class="pull-left">{{ list.name }}</div>
            <div class="pull-right">
              <div @click="handleActionClick(list)" class="more">查看更多</div>
            </div>
          </div>
          <div class="box-info w-100 cb">
            <div class="pull-left">
              <!-- <a><img src="../assets/images/img_1.png" /></a> -->
              <a><img :src="list.smAccessoryTbl.url" /></a>
            </div>
            <div class="pull-right">
              <ul class="cb">
                <li v-for="(item, index) in list.recommGoodsTbls1.slice(0, 12)" :key="index"
                  @click="clickDetails(item, '1')" v-if="item.eshopGdGoodsTbl2.state === 10">
                  <a>
                    <i><img :src="item.eshopGdGoodsTbl2.coverUrl
                      ? item.eshopGdGoodsTbl2.coverUrl
                      : '/static/img/goods_defalut.png'
                      " :alt="item.eshopGdGoodsTbl2.name" /></i>
                    <p>{{ item.eshopGdGoodsTbl2.name }}</p>
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div class="home-box4 w-100">
            <a target="_blank" v-for="ad in list.remAdInformationTblList" :href="ad.adLink"><img
                style="max-height: 10rem" :src="ad.smAccessoryTbl.url" /></a>
          </div>
        </div>

        <div class="home-box5 w-100" v-if="false">
          <div class="all-title-box w-100 between-center">
            <div class="pull-left">新品推荐</div>
            <div class="pull-right">
              <router-link to="/productList?type=recommend" class="more">查看更多</router-link>
            </div>
          </div>
          <div class="box-info w-100">
            <ul>
              <li v-for="(item, index) in recommendArry" :key="index" @click="clickDetails(item, '2')">
                <a>
                  <i><img :src="item.coverUrl
                    ? item.coverUrl
                    : '/static/img/goods_defalut.png'
                    " :alt="item.name" /></i>
                  <p>{{ item.name }}</p>
                </a>
              </li>
            </ul>
          </div>
          <!-- <div class="home-box4 w-100"><a @click="navTo('多快好省')"><img src="../assets/images/2.jpg"></a></div> -->
        </div>
        <div class="home-box6 w-100" style="display: flex;gap: 2rem;">
          <div class="box-left" style="flex: 1;">
            <div class="all-title-box w-100 between-center">
              <div class="pull-left">通知公告</div>
              <div class="pull-right">
                <router-link to="/newsCenter?id=1" class="more">查看更多</router-link>
              </div>
            </div>
            <div class="list-box1 w-100">
              <div class="bd w-100">
                <ul>
                  <li v-for="(item, index) in articleNewsArry" :key="index">
                    <router-link :to="{
                      path: '/newsDetails',
                      query: {
                        id: item.id,
                        type: 1,
                        pageIndex: 1,
                        index: index
                      }
                    }">
                      <span>{{ item.title }}</span>
                      <i v-if="item.lastTime">{{ item.lastTime.substr(0, 10) }}</i>
                    </router-link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="box-right cb" style="flex: 1;">
            <div class="all-title-box w-100 between-center">
              <div class="pull-left">新闻资讯</div>
              <div class="pull-right">
                <router-link to="/newsCenter?id=5" class="more">查看更多</router-link>
              </div>
            </div>
            <!-- 新闻列表 -->
            <div class="box-info1 w-100">
              <template v-for="(item, index) in articleNoteArry">
                <router-link :key="index" :to="{
                  path: '/newsDetails',
                  query: { id: item.id, type: 5, pageIndex: 1, index: 5 }
                }" v-if="index == 0">
                  <div class="f-l">
                    <img :src="item.smAccessoryTbl1.url
                      ? item.smAccessoryTbl1.url
                      : '/static/img/no_data1.png'
                      " :alt="item.title" />
                  </div>
                  <div class="f-r">
                    <span>{{ item.title }}</span>
                    <!-- <p v-html="item.text"></p> -->
                    <p>{{ stripHtmlTags(item.text) }}</p>
                    <i v-if="item.lastTime">{{ item.lastTime.substr(0, 10) }}</i>
                  </div>
                </router-link>
              </template>
            </div>
            <!-- 新闻列表 -->
            <div class="list-box1 w-100">
              <ul>
                <li v-for="(item, index) in articleNoteArry" :key="index" style="float: left;width: 50%;" :class="{ paddingRight15rem: index % 2 === 1 }">
                  <router-link :to="{
                    path: '/newsDetails',
                    query: {
                      id: item.id,
                      type: 5,
                      pageIndex: 1,
                      index: index
                    }
                  }" v-if="index != 0">
                    <span>{{ item.title }}</span>
                    <i v-if="item.lastTime">{{ item.lastTime.substr(0, 10) }}</i>
                  </router-link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="" :visible.sync="dialogVisible1" width="20%" :before-close="handleClose"
      :close-on-click-modal="false">
      <div class="statusIcon" style="display: flex; justify-content: center;flex-direction: column;align-items: center;">
        <div class="recommendSoftware">
          推荐使用以下软件
        </div>
        <ul class="z-link-box">
          <li>
            <a href="https://www.solidworks.com/zh-hans" target="_blank">
              <!-- <img style="" src="../../static/img/Solidworks.svg" alt=""> -->
              <span class="designTool">SOLIDWORKS</span>
            </a>
          </li>
          <li>
            <a href="https://www.autodesk.com.cn" target="_blank">
              <!-- <img style="" src="../../static/img/autodesk.svg" alt=""> -->
              <span class="designTool">欧特克</span>
            </a>
          </li>
          <li>
            <a href="https://www.zwsoft.cn" target="_blank">
              <!-- <img style="height: 32px;object-fit: contain;" src="../../static/img/zws.svg" alt=""> -->
              <span class="designTool">中望软件</span>
            </a>
          </li>
        </ul>
      </div>
      <span slot="footer" class="dialog-footer">
        <button class="conmask-btn " @click="handleOK">
          确定
        </button>
        <button class="disagree-btn" @click="handleClose">
          关闭
        </button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// const superSlide = require('../../assets/js/jquery.SuperSlide.2.1.3.js')
import {
  getCategories,
  getMessageList,
  getSlide,
  getRecommendList,
  getgoodsList,
  getGoodsDetail,
  downloadRecord
} from '../common/http.js';
import { message } from '../common/common.js';
import axios from 'axios';
export default {
  name: 'index',
  data() {
    return {
      tabbar: ['我的订单', '我的报价'],
      tabbarIndex: 0,
      // token: "",
      // userInfo: {
      //   headimgUrl: false
      // },
      dialogVisible1: false,
      categorys: [],
      articleNoteArry: [], // 公告
      articleNewsArry: [], // 新闻
      indexSlide: [],
      recommendArry: [],
      indexGoodsListArry: []
    };
  },
  computed: {
    // 富文本提取纯文字
    stripHtmlTags() {
      return (input) => {
        // 去除 HTML 标签
        const withoutHtmlTags = input.replace(/<[^>]+>/g, '')
        // 去除图片标签（可选，已通过正则去除所有标签，但如果特别想清理 <img> 标签，可以单独处理）
        const withoutImages = withoutHtmlTags.replace(/<img[^>]*>/g, '')
        const withoutSymbols = withoutImages.replace(/&([a-zA-Z]+|#\d+);/g, '')
        return withoutSymbols
      }
    },
    token() {
      console.log(this.$store.state.token)
      return this.$store.state.token
    },
    userInfo() {
      return this.$store.state.userInfo
    }
  },
  mounted() {
    // this.token = localStorage.getItem("token");
    // if (this.token) {
    //   if (localStorage.getItem("userInfo")) {
    //     this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
    //   }
    // }

    this.initCategory();
    this.indexArticle(1);
    this.indexArticle(5);
    this.indexSwiper();
    this.indexRecommend();
    this.indexGoodsList();
    // let rightHei = document.querySelectorAll('.home-box3 .box-info .pull-right');
    // let leftHei = document.querySelectorAll('.home-box3 .box-info .pull-left');
    // rightHei.forEach((item,index)=>{
    // 	leftHei[index].style.height = item.offsetHeight;
    // })
  },
  methods: {
    downloadRecordHandler(e) {
      let userInfo = {}
      try {
        userInfo = JSON.parse(localStorage.getItem('userInfo'))
      } catch (error) {}
      const data = {
        fileType: e.fileType, // 文件类型(pdf/3d)
        fileName: e.fileName, // 文件名
        userName: userInfo.userName, // 用户名
        phone: userInfo.phone, // 手机号
        firmName: userInfo.smUserFirmTbl ? userInfo.smUserFirmTbl.firmName : '', // 公司名称(企业用户)
        occupation: userInfo.smUserFirmTbl ? userInfo.smUserFirmTbl.occupation : '' // 职业(企业用户)
      }
      downloadRecord(data)
    },
    handleOK() {
      this.dialogVisible1 = false;
    },
    handleClose() {
      this.dialogVisible1 = false;
    },
    handleActionClick(item) {
      // :to="'/productList?type=category&id=' + list.id"
      this.$router.push({
        name: 'productList',
        path: '/productList',
        query: {
          type: 'category',
          id: item.id
        }
      });
    },
    cadUrl() {
      // window.open(
      //   "http://ps6.hnmnwl1.top/index.php?m=goods&a=details&content_id=29#",
      //   "_blank"
      // );
      this.dialogVisible1 = true;
    },
    handleFilterCategory(res) {
      // 递归查找所有父级节点
      const findParents = (data, targetId, path = []) => {
        for (const item of data) {
          if (item.id === targetId) {
            return [...path, item];
          }
          if (item.children) {
            const result = findParents(item.children, targetId, [
              ...path,
              item
            ]);
            if (result) {
              return result;
            }
          }
        }
        return null;
      };

      // 查找匹配的节点及其所有父级
      const parents = findParents(this.categorys, res.id);
      this.$store.commit('SET_CATEGORYDATA', parents);
      let params = {
        id: res.id
      };
      this.$store.commit('setShowDetails', false);
      this.$router.push({
        path: '/productTypeScreen',
        query: params
      });
    },
    navToOrder(path, data) {
      this.$router.push({
        name: path,
        path: '/' + path,
        query: {
          data: data
        }
      });
    },
    navToInquiry(data) {
      this.$router.push({
        name: 'meInquiry',
        path: '/meInquiry',
        query: {
          data: data
        }
      });
    },
    // 分类列表
    initCategory() {
      getCategories({
        // homeCategoryId: 15,
        // isChildren: 1,
        type: 1
      }).then(res => {
        if (res.result) {
          this.categorys = res.data;
        }
      });
    },
    changeTabbar(index) {
      this.tabbarIndex = index;
    },
    pageJumps(url, data, parent) {
      let params = {};
      if (url == '/productTypeScreen') {
        params.productId = data.id;
        params.parent = parent.name;
        params.child = data.name;
        params.childrenName = data.name;
      }
      this.$router.push({
        path: url,
        query: params
      });
    },
    pageJump(url, data, parent) {
      let params = {};
      if (url == '/productTypeScreen') {
        params.productId = data.id;
        params.parent = parent.name;
        // params.child = data.name;
        params.childrenName = data.name;
      }
      this.$router.push({
        path: url,
        query: params
      });
    },
    // 新闻资讯
    indexArticle(type, array) {
      getMessageList({
        type
      }).then(res => {
        if (type === 1) {
          this.articleNewsArry = res.data;
        } else {
          this.articleNoteArry = res.data;
        }
      });
    },
    // 轮播图
    indexSwiper() {
      getSlide({
        area: 1,
        type: 1
      }).then(res => {
        if (res.result) {
          this.indexSlide = res.data;
        }
        this.$nextTick(() => {
          new Swiper('.home-box1 .pull-cen .swiper-container', {
            loop: true,
            speed: 1000,
            observer: true,
            observeParents: true,
            autoplay: {
              delay: 4000,
              disableOnInteraction: false
            },
            pagination: {
              el: '.home-box1 .pull-cen .swiper-pagination',
              clickable: true
            }
          });
        });
      });
    },
    // 新品推荐
    indexRecommend() {
      getgoodsList({
        recommend: 1,
        pageSize: 14,
        state: 10
      }).then(res => {
        if (res.result) {
          this.recommendArry = res.data.rows;
        }
      });
    },
    clickDetails(item, type) {
      let params = {};
      let res = {};
      if (type === '1') {
        params.uid = item.eshopGdGoodsTbl2.uid;
        params.childrenName = item.eshopGdGoodsTbl2.category.name;
        params.productId = item.eshopGdGoodsTbl2.category.id;
      } else {
        params.uid = item.uid;
        params.childrenName = item.category.name;
        params.productId = item.category.id;
      }

      // 递归查找所有父级节点
      const findParents = (data, targetId, path = []) => {
        for (const item of data) {
          if (item.id === targetId) {
            return [...path, item];
          }
          if (item.children) {
            const result = findParents(item.children, targetId, [
              ...path,
              item
            ]);
            if (result) {
              return result;
            }
          }
        }
        return null;
      };

      // 查找匹配的节点及其所有父级
      const parents = findParents(this.categorys, params.productId);
      this.$store.commit('SET_CATEGORYDATA', parents);
      const routerJump = this.$router.resolve({
        name: 'productTypeScreen',
        path: '/productTypeScreen',
        query: params
      });

      window.open(routerJump.href, '_blank');
    },
    // 商品列表
    indexGoodsList() {
      getRecommendList({
        pageSize: 62,
        orderBy: 'id desc',
        state: 10,
        deleted: 'n',
        type: 2
      }).then(res => {
        if (res.result) {
          this.indexGoodsListArry = res.data;
        }
      });
    },
    undeveloped() {
      window.open('https://hxfahlx.huixinggroup.com/accessory/20250527.zip', '_blank');
      this.downloadRecordHandler({ fileType: '3d', fileName: '3D图库' })
      // message({
      //   message: "功能暂未开放",
      //   type: "warning"
      // });

      // const loading = this.$loading({
      //   lock: true,
      //   text: 'Loading',
      //   spinner: 'el-icon-loading',
      //   background: 'rgba(255, 255, 255, 0.5)'
      // })
      // const token = localStorage.getItem('token');
      // const cookie = localStorage.getItem('cookie')
      // axios({
      //   url: 'https://hxfahlx.huixinggroup.com/accessory/20250527.zip', // 替换为实际的下载接口地址
      //   headers: {
      //     'Content-Type': 'multipart/form-data',
      //     // Cookie: cookie,
      //     token: token
      //   },
      //   method: 'GET',
      //   responseType: 'blob' // 设置响应类型为blob
      // }).then(response => {
      //   const blob = new Blob([response.data])
      //   const url = window.URL.createObjectURL(blob)

      //   const a = document.createElement('a')
      //   a.href = url
      //   a.download = '汇利兴自动化输送零部件3D选型.zip' // ⭐ 自定义文件名
      //   document.body.appendChild(a)
      //   a.click()

      //   document.body.removeChild(a)
      //   window.URL.revokeObjectURL(url)

      //   loading.close()
      // }).catch(error => {
      //   loading.close()
      //   console.error('下载文件时出错:', error)
      // })
    },
    goLogin() {
      $('.login-eject').fadeIn();
    },
    goProductDetail(item) {
      const that = this
      // 递归查找所有父级节点
      const findParents = (data, targetId, path = []) => {
        for (const item of data) {
          if (item.id === targetId) {
            return [...path, item];
          }
          if (item.children) {
            const result = findParents(item.children, targetId, [
              ...path,
              item
            ]);
            if (result) {
              return result;
            }
          }
        }
        return null;
      }

      function getQueryParam(name) {
        if (!item.linkUrl) return null

        const hash = item.linkUrl
        const query = hash.split('?')[1]
        if (!query) return null

        const params = new URLSearchParams(query)
        return params.get(name)
      }

      switch (item.linkType) {
        case 0:
          break
        case 1:
          const id = getQueryParam('id')
          if (id) {
            const parents = findParents(this.categorys, Number(id))
            this.$store.commit('SET_CATEGORYDATA', parents)
          }
          window.open(item.linkUrl, '_blank')
          break
        case 2:
          const userId = JSON.parse(localStorage.getItem('userInfo'))
          getGoodsDetail({ uid: item.linkUrl, userId: userId ? userId.id : '' }).then((res) => {
            const goodsDetail = res.data
            that.clickDetails(goodsDetail, '2')
          })
          break
        case 3:
          const parents = findParents(this.categorys, Number(item.linkUrl))
          this.$store.commit('SET_CATEGORYDATA', parents)
          this.$router.push({
            path: '/productTypeScreen',
            query: {
              id: item.linkUrl
            }
          })
          break
      }

      // const linkTypeOptions: [
      // 	{
      // 		'label': '无',
      // 		'value': 0
      // 	},
      // 	{
      // 		'label': '链接',
      // 		'value': 1
      // 	},
      // 	{
      // 		'label': '商品详情',
      // 		'value': 2
      // 	},
      // 	{
      // 		'label': '二级分类',
      // 		'value': 3
      // 	}
      // ],
    }
  }
};
</script>

<style>
.paddingRight15rem {
  padding-right: 1.5rem;
}

.text-one-hide {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}

.more {
  cursor: pointer;
}

.index-box {
  overflow: hidden;
}

.hide-scrollbar {
  overflow: hidden;
  /* 隐藏滚动条 */
  -ms-overflow-style: none;
  /* IE和Edge浏览器 */
  scrollbar-width: none;
  /* Firefox浏览器 */
}

.hide-scrollbar::-webkit-scrollbar {
  display: none;
  /* Safari和Chrome浏览器 */
}

.conmask-btn {
  width: 142px;
  height: 36px;
  background: #ffcc00;
  font-size: 14px;
  font-weight: 400;
  color: #4a4a4a;
  line-height: 20px;
  position: relative;
  display: flex;
  text-decoration: none;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
  border: none;
}

.disagree-btn {
  border: none;
  width: 142px;
  height: 36px;
  font-size: 14px;
  font-weight: 400;
  color: #4a4a4a;
  line-height: 20px;
  position: relative;
  display: flex;
  text-decoration: none;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  border: 1px solid #ffcc00;
}

.dialog-footer {
  display: flex;
  justify-content: center;
  align-items: center;
}

.z-link-box li {
  margin: 15px 0;
  font-weight: bold;
}

.recommendSoftware {
  background-color: #bfcde8;
  color: #023aa4;
  font-size: 1.1rem;
  height: 2.2rem;
  border-radius: 1.1rem;
  font-weight: bold;
  padding: 0 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.designTool {
  position: relative;
  font-size: 1rem;
}
.designTool::after {
  content: '';
  position: absolute;
  left: -1rem;
  top: 50%;
  transform: translateY(-50%);
  background-color: #333;
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 50%;
}
</style>



// WEBPACK FOOTER //
// src/pages/index.vue